// extracted by mini-css-extract-plugin
export default {"pokemon":"Pokemon_pokemon__DICnp","name":"Pokemon_name__tkknK","img":"Pokemon_img__kwpbD","waza_list":"Pokemon_waza_list__KqpHI"};